import { isAllowedCountryCode } from '@artem-lex/common-server/countries'
import { z } from 'zod'

/** Error codes returned by the schema; map to i18n keys in the component. */
export const ADD_ASSOCIATED_PARTY_VALIDATION_CODES = {
  name_required: 'addModal.validationName',
  country_required: 'addModal.validationCountryRequired',
  country_invalid_length: 'addModal.validationCountryLength',
  country_unsupported: 'addModal.validationCountryUnsupported',
  city_required: 'addModal.validationCityRequired',
} as const

export type AddAssociatedPartyValidationCode =
  keyof typeof ADD_ASSOCIATED_PARTY_VALIDATION_CODES

const optionalString = z
  .string()
  .transform((string) => (string.trim() === '' ? undefined : string.trim()))

const requiredCountryString = z
  .string()
  .trim()
  .min(1, 'country_required')
  .refine((val) => val.length === 2, {
    message: 'country_invalid_length',
  })
  .refine(isAllowedCountryCode, {
    message: 'country_unsupported',
  })

const requiredCityString = z.string().trim().min(1, 'city_required')

export const addAssociatedPartyFormSchema = z.object({
  name: z.string().trim().min(1, 'name_required'),
  street: optionalString,
  street2: optionalString,
  streetNumber: optionalString,
  subDivision: optionalString,
  country: requiredCountryString,
  postCode: optionalString,
  poBox: optionalString,
  city: requiredCityString,
  contactName: optionalString,
  contactPhoneNumber: optionalString,
  contactEmail: optionalString,
})

export type AddAssociatedPartyFormValues = z.infer<
  typeof addAssociatedPartyFormSchema
>
